import { SVGIconComponent } from './types';

export const BackToSearch: SVGIconComponent = ({ className, color, style }) => (
  <svg
    width="35px"
    height="18px"
    viewBox="0 0 35 18"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    style={{ color, ...style }}
    className={className}
  >
    <g id="Retail" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="Book-Order-2c---multi-match"
        transform="translate(-29.000000, -276.000000)"
        fill="#848484"
        fillRule="nonzero"
      >
        <g id="Back-button" transform="translate(19.000000, 257.000000)">
          <g id="icon-back-to-search" transform="translate(10.000000, 19.000000)">
            <path
              d="M29.9541613,11.5935457 L35,16.6393844 L33.6393844,18 L28.5935457,12.9541613 C27.3795231,13.8825514 25.8628848,14.4331771 24.2165885,14.4331771 C20.2305299,14.4331771 17,11.2026472 17,7.21658853 C17,3.23052991 20.2305299,0 24.2165885,0 C28.2026472,0 31.4331771,3.23052991 31.4331771,7.21658853 C31.4331771,8.86288482 30.8825514,10.379475 29.9541613,11.5935457 L29.9541613,11.5935457 Z M24.2164923,12.5087535 C27.1388258,12.5087535 29.5086572,10.138922 29.5086572,7.21658853 C29.5086572,4.29425506 27.1388258,1.92442361 24.2164923,1.92442361 C21.2941588,1.92442361 18.9243274,4.29425506 18.9243274,7.21658853 C18.9243274,10.138922 21.2941588,12.5087535 24.2164923,12.5087535 Z"
              id="Shape"
            ></path>
            <path
              d="M7.7189441,2.26286504 C7.54878837,2.094635 7.31749003,2 7.0773209,2 C6.83626697,2 6.60496863,2.09463052 6.43481291,2.26286504 L0.265873985,8.35772713 C0.0957182645,8.52595717 0,8.75376307 0,8.99208896 C0,9.23041484 0.095713727,9.45822074 0.265873985,9.62645078 L6.43481291,15.7213129 C6.60319674,15.8965525 6.83715178,15.9973223 7.08176764,16 C7.32636082,16.0025751 7.5621059,15.907945 7.73491605,15.7362068 C7.90773073,15.5653479 8.00344446,15.3322753 7.99990522,15.0904502 C7.99636598,14.8486252 7.89444497,14.6181724 7.71719716,14.451692 L2.18985875,8.99206653 L7.71719716,3.53244105 C7.88735288,3.36421102 7.98395596,3.13640512 7.98395596,2.89807923 C7.98484213,2.65975334 7.88912931,2.43107265 7.71896678,2.26284261 L7.7189441,2.26286504 Z"
              id="Path"
            ></path>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
